import { render, staticRenderFns } from "./HeaderChildren.vue?vue&type=template&id=aa383c3e&scoped=true&"
import script from "./HeaderChildren.vue?vue&type=script&lang=js&"
export * from "./HeaderChildren.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChildren.vue?vue&type=style&index=0&id=aa383c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa383c3e",
  null
  
)

export default component.exports